// import React from 'react';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useStore } from '../../../../hook-store/store';

import { appInstallHandler } from '../../../../utils/ui/ui-util';
import { logoutHandler } from '../../../../utils/user/user';
import { marks } from '../../../../utils/marks';

import { 
  loginPageLink, 
  signupPageLink,
  drawDreamerLink,
  dreamInpaniterLink,
 } from '../../../../App';

import './ToggleNavItems.css';


const ToggleNavItems = props => {
  // console.log('ToggleNavItems-props', props);

const [t] = useTranslation('translation');
// {t('termsOfUse.text1', 'terms of use')}

  const [store, dispatch] = useStore();
  const { 
    isAuth, 
    deferredPrompt, 
  }  = store.uiStore;

  const navItems = [
    { 
      id: 'bucket-object', 
      // text: 'feed',
      text: `${t('nav.01', 'Files')}`, 
      link: '/', 
      auth: true
    },
    { 
      id: 'image-editor', 
      // text: 'feed',
      text: `${t('nav.08', 'Image Editor')}`, 
      link: '/image-editor', 
      auth: false
    },
    { 
      id: 'image-cleaner', 
      // text: 'feed',
      text: 'Image Cleaner', 
      link: '/image-cleaner', 
      auth: false
    },
    { 
      id: 'dream-inpainter', 
      // text: 'feed',
      text: 'Dream Inpainter', 
      link: '/image-cleaner', 
      auth: false
    },
    { 
      id: 'bg-remover', 
      // text: 'feed',
      text: 'Background Remover', 
      link: '/image-cleaner', 
      auth: false
    },
    { 
      id: 'illust-generator', 
      // text: 'feed',
      text: 'Illustration Generator', 
      link: '/image-cleaner', 
      auth: false
    },
    { 
      id: 'draw-dreamer', 
      // text: 'feed',
      text: 'Draw Dreamer', 
      link: '/image-resizer', 
      auth: false
    },
    // { 
    //   id: 'image-fusion', 
    //   // text: 'feed',
    //   text: 'Image Fusion', 
    //   link: '/image-fusion', 
    //   auth: false
    // },
    { 
      id: 'image-combiner', 
      // text: 'feed',
      text: 'Image Combiner', 
      link: '/image-combiner', 
      auth: false
    },
    { 
      id: 'image-merger', 
      // text: 'feed',
      text: 'Image Merger', 
      link: '/image-merger', 
      auth: false
    },
    { 
      id: 'image-resizer', 
      // text: 'feed',
      text: 'Image Resizer', 
      link: '/image-resizer', 
      auth: false
    },
    { 
      id: 'image-convert', 
      // text: 'feed',
      text: 'Image Convert', 
      link: '/image-convert', 
      auth: false
    },
    { 
      id: 'userinfo', 
      // text: 'feed',
      text: `${t('nav.02', 'User Info')}`, 
      link: '/userinfo', 
      auth: true
    },
    { 
      id: 'login', 
      // text: 'feed',
      text: `${t('nav.03', 'Login')}`, 
      link: '/feed/posts', 
      auth: false
    },
    { 
      id: 'signup', 
      // text: 'feed',
      text: `${t('nav.04', 'Signup')}`, 
      link: '/feed/posts', 
      auth: false
    },
    { 
      id: 'install-app', 
      // text: 'feed',
      text: `${t('nav.05', 'Install App')}`, 
      link: '/', 
      auth: false
    },
    { 
      id: 'logout', 
      // text: 'feed',
      text: `${t('nav.06', 'Logout')}`, 
      link: '/feed/posts', 
      auth: true
    },
  ];


  const logoutConfirm = () => {
    if (window.confirm(`${t('nav.07', "Is it no problem to logout?")}`)) {
      console.log('confirm true');
      // props.onLogout();

      dispatch('SET_ISAUTH', false);
      logoutHandler(); 
    }
  }

  let toggleNavItemsBody;

  toggleNavItemsBody = (
    <ul>
      {navItems.map(item => {
        if (item.id === 'image-editor') {
          return (
            <div className="toggleNavItem">
              <Link to={item.link} 
                title={'simple image editor'}
                onClick={() => {
                  dispatch('SET_SHOWTOGGLENAV', false);
                  // dispatch('SET_DISPLAYTABLE', '');
                }}
              >
                <span className='toggleNavItemIcon'>
                  {/* {marks.listUlMark} */}
                  {marks.paintBrushMark} 
                </span> 
                <span className='toggleNavItemText'>
                  {item.text}
                </span>
              </Link>
            </div>
          );
        }

        if (item.id === 'image-cleaner') {
          return (
            <div className="toggleNavItem">
              <Link to={item.link} 
                title={'Image cleaner for removing objects from image'}
                onClick={() => {
                  dispatch('SET_SHOWTOGGLENAV', false);
                  // dispatch('SET_DISPLAYTABLE', '');
                }}
              >
                <span className='toggleNavItemIcon'>
                  {/* {marks.listUlMark} */}
                  {marks.eraserMark}
                </span> 
                <span className='toggleNavItemText'>
                  {item.text}
                </span>
              </Link>
            </div>
          );
        }

        if (item.id === 'dream-inpainter') {
          // let inpainterLink = dreamInpaniterLink;
          // if (localStorage.getItem('tokenForCasTGT') && localStorage.getItem('TGTexp')) {
          //   inpainterLink = `${inpainterLink}/?tokenForCasTGT=${localStorage.getItem('tokenForCasTGT')}&TGTexp=${localStorage.getItem('TGTexp')}`
          // }

          return (
            <div className="toggleNavItem">
              <a 
                title={'Tools for image edit, including Dream Inpainter, Background Remover, illustration Generator'}
                href={dreamInpaniterLink} 
                target="_blank"
                rel="noreferrer noopener"
                onClick={() => {
                  dispatch('SET_SHOWTOGGLENAV', false);
                  // dispatch('SET_DISPLAYTABLE', '');
                }}
              >
                <span className='toggleNavItemIcon'>
                  {marks.paintBrushMark}
                </span> 
                <span className='toggleNavItemText'>
                  Dream Inpainter {marks.externalLinkMark}
                </span>
              </a>
            </div>
          );
        }

        if (item.id === 'bg-remover') {
          return (
            <div className="toggleNavItem">
              <a 
                title={'Tools for image edit, including Dream Inpainter, Background Remover, illustration Generator'}
                href={`${dreamInpaniterLink}/background-remover`} 
                target="_blank"
                rel="noreferrer noopener"
                onClick={() => {
                  dispatch('SET_SHOWTOGGLENAV', false);
                  // dispatch('SET_DISPLAYTABLE', '');
                }}
              >
                <span className='toggleNavItemIcon'>
                  {marks.paintBrushMark}
                </span> 
                <span className='toggleNavItemText'>
                  Background Remover {marks.externalLinkMark}
                </span>
              </a>
            </div>
          );
        }
        if (item.id === 'illust-generator') {
          return (
            <div className="toggleNavItem">
              <a 
                title={'Tools for image edit, including Dream Inpainter, Background Remover, illustration Generator'}
                href={`${dreamInpaniterLink}/illustration-generator`} 
                target="_blank"
                rel="noreferrer noopener"
                onClick={() => {
                  dispatch('SET_SHOWTOGGLENAV', false);
                  // dispatch('SET_DISPLAYTABLE', '');
                }}
              >
                <span className='toggleNavItemIcon'>
                  {marks.paintBrushMark}
                </span> 
                <span className='toggleNavItemText'>
                  Illustration Generator {marks.externalLinkMark}
                </span>
              </a>
            </div>
          );
        }

        if (item.id === 'draw-dreamer') {
          // let drawDreamerlink = drawDreamerLink;

          // if (localStorage.getItem('tokenForCasTGT') && localStorage.getItem('TGTexp')) {
          //   drawDreamerlink = `${drawDreamerLink}/?tokenForCasTGT=${localStorage.getItem('tokenForCasTGT')}&TGTexp=${localStorage.getItem('TGTexp')}`
          // }

          return (
            <div className="toggleNavItem">
              <a 
                title={'Tools for image genaration, Draw Dreamer, Text Prompt Image Generation'}
                href={drawDreamerLink} 
                target="_blank"
                rel="noreferrer noopener"
                onClick={() => {
                  dispatch('SET_SHOWTOGGLENAV', false);
                  // dispatch('SET_DISPLAYTABLE', '');
                }}
              >
                <span className='toggleNavItemIcon'>
                  {marks.pictureOMark}
                </span> 
                <span className='toggleNavItemText'>
                  Draw Dreamer {marks.externalLinkMark}
                </span>
              </a>
            </div>
          );
        }

        if (item.id === 'image-combiner') {
          return (
            <div className="toggleNavItem">
              <Link to={item.link} 
                title={'tool to combine two input images and generate a new mixed image.'}
                onClick={() => {
                  dispatch('SET_SHOWTOGGLENAV', false);
                  // dispatch('SET_DISPLAYTABLE', '');
                }}
              >
                <span className='toggleNavItemIcon'>
                  {marks.objectGroupMark}
                </span> 
                <span className='toggleNavItemText'>
                  {item.text}
                </span>
              </Link>
            </div>
          );
        }

        if (item.id === 'image-merger') {
          return (
            <div className="toggleNavItem">
              <Link to={item.link} 
                title={'tool to merge images.'}
                onClick={() => {
                  dispatch('SET_SHOWTOGGLENAV', false);
                  // dispatch('SET_DISPLAYTABLE', '');
                }}
              >
                <span className='toggleNavItemIcon'>
                  {marks.objectGroupMark}
                </span> 
                <span className='toggleNavItemText'>
                  {item.text}
                </span>
              </Link>
            </div>
          );
        }

        // if (item.id === 'image-fusion') {
        //   return (
        //     <div className="toggleNavItem">
        //       <Link to={item.link} 
        //         title={'Tool for generating a fusion image from two images.'}
        //         onClick={() => {
        //           dispatch('SET_SHOWTOGGLENAV', false);
        //           // dispatch('SET_DISPLAYTABLE', '');
        //         }}
        //       >
        //         <span className='toggleNavItemIcon'>
        //           {marks.objectGroupMark}
        //         </span> 
        //         <span className='toggleNavItemText'>
        //           {item.text}
        //         </span>
        //       </Link>
        //     </div>
        //   );
        // }

        if (item.id === 'image-resizer') {
          return (
            <div className="toggleNavItem">
              <Link to={item.link} 
                title={'tool for resizing multiple images'}
                onClick={() => {
                  dispatch('SET_SHOWTOGGLENAV', false);
                  // dispatch('SET_DISPLAYTABLE', '');
                }}
              >
                <span className='toggleNavItemIcon'>
                  {marks.compressMark}
                </span> 
                <span className='toggleNavItemText'>
                  {item.text}
                </span>
              </Link>
            </div>
          );
        }

        if (item.id === 'image-convert') {
          return (
            <div className="toggleNavItem">
              <Link to={item.link} 
                title={'tool for converting image file format'}
                onClick={() => {
                  dispatch('SET_SHOWTOGGLENAV', false);
                  // dispatch('SET_DISPLAYTABLE', '');
                }}
              >
                <span className='toggleNavItemIcon'>
                  {marks.exchangeMark}
                </span> 
                <span className='toggleNavItemText'>
                  {item.text}
                </span>
              </Link>
            </div>
          );
        }
        

        if (!isAuth && item.id === 'login') {
          return (
            <div className="toggleNavItem">
              <span>
                <a href={loginPageLink} >
                  <span className='toggleNavItemIcon'>
                    {marks.signInMrak}
                  </span> 
                  <span className='toggleNavItemText'>
                    {item.text}
                  </span>
                </a>
              </span>
            </div>
          );
        }

        if (!isAuth && item.id === 'signup') {
          return (
            <div className="toggleNavItem">
              <span>
                <a href={signupPageLink} >
                <span className='toggleNavItemIcon'>
                  {marks.userPlusMrak}
                </span> 
                <span className='toggleNavItemText'>
                  {item.text}
                </span>
                </a>
              </span>
            </div>
          );
        }

        if (isAuth && item.id === 'bucket-object') {
          return (
              <div className="toggleNavItem">
                <Link to={item.link} 
                  onClick={() => {
                    dispatch('SET_SHOWTOGGLENAV', false);
                    // dispatch('SET_DISPLAYTABLE', '');
                  }}
                >
                  <span className='toggleNavItemIcon'>
                    {/* {marks.listUlMark} */}
                    {marks.thLargeMark} 
                  </span> 
                  <span className='toggleNavItemText'>
                    {item.text}
                  </span>
                </Link>
              </div>
          );
        }

        if (isAuth && item.id === 'userinfo') {
          return (
              <div className="toggleNavItem">
                <Link to={item.link} 
                  onClick={() => {
                    dispatch('SET_SHOWTOGGLENAV', false);
                  }}
                >
                  <span className='toggleNavItemIcon'>
                    {marks.userMrak} 
                  </span> 
                  <span className='toggleNavItemText'>
                    {item.text}
                  </span>
                </Link>
              </div>
          );
        }

        if (deferredPrompt && item.id === 'install-app') {
          return (
            <div className="toggleNavItem">
              <Link to={item.link} 
                onClick={() => {
                  appInstallHandler(deferredPrompt);
                  // dispatch('SET_SHOWTOGGLENAV', false);
                }}
              >
                <span className='toggleNavItemIcon'>
                  {marks.plusSquareOMark} 
                </span> 
                <span className='toggleNavItemText'>
                  {item.text}
                </span>
              </Link>
            </div>
          );          
        }

        if (isAuth && item.id === 'logout') {
          return (
              <div className="toggleNavItem">
                <span
                  onClick={() => { logoutConfirm(); }} 
                >
                <span className='toggleNavItemIcon'>
                  {marks.signOutMrak} 
                </span> 
                <span className='toggleNavItemText'>
                  {item.text}
                </span>
                </span>
              </div>
          );
        }

        else {
          return null;
        }

        // return (
        //   <div  className="toggleNavItem">
        //     <span>
        //     <span className='toggleNavItemIcon'>
        //       {item.text}
        //       {/* {marks.userMrak}  */}
        //       </span> 
        //     </span>
        //   </div>
        // );
      })}
    </ul>
  );

  return (
  <Fragment>
    {toggleNavItemsBody}
  </Fragment>
  );

  }
export default ToggleNavItems;
